import axios from 'axios';
import { ReportData } from 'organisms/CloudOpsReportAdmin/types';
import {
  BulkJobAction,
  ListBulkJobsResponse,
  ProjectReportBulkJob,
  ProjectReportsQuery,
  TriggerBulkActionResponse,
} from 'organisms/CloudOpsReportAdmin/bulk/types';

const getBaseUrl = () => process.env.REACT_APP_USER_SERVICE || '';

export const bulkApi = {
  async trigger(
    action: BulkJobAction,
    reportIds: number[]
  ): Promise<TriggerBulkActionResponse> {
    const { data } = await axios.post<TriggerBulkActionResponse>(
      `${getBaseUrl()}/project/reports/bulk-action`,
      { action, report_ids: reportIds }
    );
    return data;
  },

  async getJob(id: number): Promise<ProjectReportBulkJob> {
    const { data } = await axios.get<ProjectReportBulkJob>(
      `${getBaseUrl()}/project/reports/bulk-jobs/${id}`
    );
    return data;
  },

  async listJobs(page = 1, limit = 20): Promise<ListBulkJobsResponse> {
    const { data } = await axios.get<ListBulkJobsResponse>(
      `${getBaseUrl()}/project/reports/bulk-jobs`,
      { params: { page, limit } }
    );
    return data;
  },

  async getReports(
    query: ProjectReportsQuery,
    page: number,
    limit: number
  ): Promise<ReportData> {
    const { data } = await axios.get<ReportData>(
      `${getBaseUrl()}/projects/reports`,
      { params: { ...query, page, limit } }
    );
    return data;
  },
};

export async function collectEligibleReportIds(
  query: ProjectReportsQuery
): Promise<number[]> {
  const limit = 200;
  const ids = new Set<number>();
  let page = 1;
  let total = 0;

  do {
    // eslint-disable-next-line no-await-in-loop
    const data = await bulkApi.getReports(query, page, limit);
    total = data.count || 0;
    (data.projects_reports || []).forEach((report) => {
      if (!report.invoice_number) ids.add(report.id);
    });
    page += 1;
  } while ((page - 1) * limit < total);

  return Array.from(ids);
}
